module.exports = __webpack_public_path__ + "img/waiting.cb9c0946.svg";